export function normalizedAuthorsList (authors) {
  const authorsArray = authors.split("\r\n");
  
  try {
    const result =  authorsArray.reduce((prevState, currentValue) => {
      const [role, people] = currentValue.split(":");

      if (!role || !people) return prevState;

      const dividedPeople = people.split(",");

      return [
        ...prevState,
        {
          role: role.trim(),
          people: dividedPeople.map((item) => item.trim()),
        },
      ];
    }, []);

    return result;
  } catch(e) {
    console.error(e);

    return [{
      role: "",
      people: []
    }]
  }
};
